import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { ApocalypseFreespinIdlePresentation } from "../freespin/ApocalypseFreespinIdlePresentation";

export class ApocalypseFreespinBetterIdlePresentation extends ApocalypseFreespinIdlePresentation {
    constructor() {
        super(`ApocalypseFreespinBetterIdlePresentation`);
    }

    protected get gameMode(): AbstractGameMode {
        return AbstractGameMode.FREESPIN_BETTER;
    }
}
